const API = 'https://i7yfaocjv0.execute-api.us-east-1.amazonaws.com/Prod';

const getToken = () => localStorage.getItem('c3_token');

const headers = (auth = false) => {
  const h = { 'Content-Type': 'application/json' };
  if (auth) h['Authorization'] = getToken();
  return h;
};

const refreshToken = async () => {
  const rt = localStorage.getItem('c3_refresh');
  if (!rt) return false;
  try {
    const res = await fetch(`${API}/auth/refresh`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken: rt })
    });
    if (!res.ok) return false;
    const data = await res.json();
    localStorage.setItem('c3_token', data.idToken);
    return true;
  } catch { return false; }
};

const api = async (path, opts = {}) => {
  let res;
  try {
    res = await fetch(`${API}${path}`, opts);
  } catch {
    if (opts.headers?.Authorization) {
      const refreshed = await refreshToken();
      if (refreshed) {
        opts.headers.Authorization = getToken();
        res = await fetch(`${API}${path}`, opts);
      } else {
        forceLogout();
        throw new Error('Session expired');
      }
    } else {
      throw new Error('Network error');
    }
  }
  if (res.status === 401 && opts.headers?.Authorization) {
    const refreshed = await refreshToken();
    if (refreshed) {
      opts.headers.Authorization = getToken();
      res = await fetch(`${API}${path}`, opts);
    } else {
      forceLogout();
      throw new Error('Session expired');
    }
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
};

const forceLogout = () => {
  localStorage.removeItem('c3_token');
  localStorage.removeItem('c3_refresh');
  localStorage.removeItem('c3_email');
  window.location.href = '/login';
};

export const auth = {
  register: (email, password) =>
    api('/auth/register', { method: 'POST', headers: headers(), body: JSON.stringify({ email, password }) }),
  login: (email, password) =>
    api('/auth/login', { method: 'POST', headers: headers(), body: JSON.stringify({ email, password }) }),
};

export const collections = {
  getAll: () => api('/collections'),
  getById: (id) => api(`/collections/${id}`),
  getCards: (id) => api(`/collections/${id}/cards`, { headers: headers(true) }),
};

export const purchases = {
  checkout: (collectionId) =>
    api('/purchases/checkout', { method: 'POST', headers: headers(true), body: JSON.stringify({ collectionId }) }),
  myCollections: () => api('/purchases/my-collections', { headers: headers(true) }),
};

export const progress = {
  rate: (cardId, collectionId, rating) =>
    api('/progress/rate', { method: 'POST', headers: headers(true), body: JSON.stringify({ cardId, collectionId, rating }) }),
  get: (collectionId) => api(`/progress/${collectionId}`, { headers: headers(true) }),
  getSession: (collectionId, limit, domain) => {
    let url = `/progress/${collectionId}/session?limit=${limit}`;
    if (domain) url += `&domain=${encodeURIComponent(domain)}`;
    return api(url, { headers: headers(true) });
  },
};
